import {defaultSelectedDocumentProduct, defaultTableSearchGlobal} from "../inventory-movements/state";

export default {
    error: false,
    message: 'Cargando ...',
    loading: {
        module:false,
        change_Trm:false,
    },
    deleted:false,
    watchDocumument:false,
    branchoffices :[],
    documentsProdcuts: [],
    models_lite: [],
    contacts_customers: [],
    warehousesContacts: [],
    sellers: [],
    accounts:[],
    projects:[],
    states_backorder:[],
    fiscalResponsibilitys: [],
    documents_products:[],
    typesOperations:[],
    products:[],
    accounts_rete_fte:[],
    tableDocuments: {
        data: [],
        columns:[],
        loading: false,
        params: {
            warehouse_id:null,
            branchoffice_id:null,
            vouchertype_id:null,
            prefix :null,
            consecutive :null,
        }
    },
    paramsquery:{
        is_customer: false,
        is_provider: false,
        is_employee: false,
        filter_customer: [],
        filter_provider: [],
        filter_employee: [],
        paginate: true,
        page: 1,
        perPage: 50,
        query: '',
        filter: '',
        sortBy: 'id',
        sort: 'ASC',
        only_active:true,
    },
    branchOfficeWarehousesDocs:[],
    default_document_product :{
        id :null,
        index :null,
        product_id :null,
        description :"",
        quantity :0,
        unit_value_before_taxes :0,
        branchoffice_warehouse_id :0,
        discount_value :0,
        total_value_brut :0,
        total_value_iva :0,
        total_value :0,
        inventory_cost_value :0,
        operationType_id :null,
        fixed_cost :false,
        manage_inventory :true,
        account_id :null,
        center_cost_id :null,
        unit_balance :0,
        value_balance :0,
        backorder_quantity :0,
        backorder_value :0,
        brand_id:null,
        line_id:null,
        subline_id:null,
        product_repeat_number:null,
        branchoffice_warehouse : {
            branchoffice_id : null,
            branchoffice:{}
        }
    },
    update_document :{
        id :null,
        branchoffice_id :null,
        vouchertype_id :null,
        prefix :"",
        consecutive :null,
        document_date :null,
        model_id :null,
        contact_id :null,
        thread :null,
        seller_id :null,
        observation :null,
        account_id :null,
        ret_fue_total :null,
        ret_iva_total :null,
        ret_ica_total :null,
        ret_ica_account_id :null,
        total_value :null,
        documents_information:{
            ret_fte_account_id :null,
        },
        products :[]
    },
    document_files_new : [],
    document_files_delete : [],
    document_files :[],
    apply_vat: true,
    cost_center_1: [],
};



// WEBPACK FOOTER //
// ./src/modules/manage-inventory-documents/state.js